import { PropsWithChildren, useCallback } from 'react'

import { UseFlowResponse } from '@cash-web/shared-flow-feature-main'
import { JourneyData } from '@cash-web/shared-journey-util-main'
import {
  CashRequestMiddleware,
  OptionalMiddlewareProvider,
  OptionalMiddlewareRequest,
} from '@cash-web/shared-util-fetch'

export const JourneyBaggageMiddleware = ({
  journey,
  flow,
  children,
}: PropsWithChildren<{
  journey?: JourneyData
  flow?: UseFlowResponse
}>) => {
  const addJourneyBaggageMiddleware: CashRequestMiddleware = useCallback(
    request => {
      const headers = request.headers as Record<string, string>

      if (journey?.journeyId != null) {
        headers['ot-baggage-uj_id'] = journey.journeyId
      }
      if (journey?.routeConfig?.id != null) {
        headers['ot-baggage-uj_name'] = journey?.routeConfig.id
      }
      if (flow?.isInProgress && flow?.trackingFlowName != null) {
        headers['ot-baggage-uj_flow_name'] = flow.trackingFlowName
      }
      // Blocker copy is rendered verbatim from the server, so a locale-pinned journey has to ask
      // for that copy in its own locale rather than the customer's.
      if (journey?.opts?.scope?.localeOverride != null) {
        headers['Accept-Language'] = journey.opts.scope.localeOverride
      }

      return request
    },
    [journey, flow?.isInProgress, flow?.trackingFlowName]
  )

  const journeyMiddleware: OptionalMiddlewareRequest = useCallback(
    (middleware: CashRequestMiddleware[]) => {
      return [...middleware, addJourneyBaggageMiddleware]
    },
    [addJourneyBaggageMiddleware]
  )

  return (
    <OptionalMiddlewareProvider name="JourneyBaggageMiddleware" request={journeyMiddleware}>
      {children}
    </OptionalMiddlewareProvider>
  )
}
